import { UtcTime } from 'types';
import * as Moment from 'moment';

export const startOfTodayOnServer = (tzOffsetCalculator: (t: UtcTime) => number): UtcTime => {
    const utcNow: UtcTime = Date.now();
    return Moment.utc(utcNow)
        .utcOffset(tzOffsetCalculator(utcNow))
        .startOf('day')
        .valueOf();
};




// WEBPACK FOOTER //
// ./src/logic/timezones.ts